import { useState, useContext } from "react";
import Grid from "@mui/material/Grid";
import FittingInformation from "../../components/FittingInformation";
import Selection from "../../components/Selection";
import Alert from "@mui/material/Alert";
import { v4 as uuidv4 } from "uuid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Context } from "../../context/FittingContext";
import WebSocketConnection from "../../utils/WebSocketConnection";
import { Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import CopyButton from "../../components/CopyButton";
import { startFitting } from "../../api/ScoringApi";

const InitialConfigs = ({ increaseStep }) => {
  const [fittingInfoFilled, setFittingInfoFilled] = useState(false);
  const [startFittingError, setStartFittingError] = useState(false);
  const [retryCount, setRetryCount] = useState(0);
  const { clubState, setSelectedShaft, setSelectedHead } = useContext(Context);

  const allowRetry = retryCount < 2;

  const onRecordSwings = async () => {
    const fittingStartedSessionId = localStorage.getItem(
      "fittingStartedSessionId"
    );
    if (fittingStartedSessionId) {
      increaseStep();
      WebSocketConnection.captureData = true;
    } else {
      const newFittingStartedSessionId = uuidv4();
      localStorage.setItem(
        "fittingStartedSessionId",
        newFittingStartedSessionId
      );
      const success = await startFitting(newFittingStartedSessionId);
      if (success) {
        increaseStep();
        WebSocketConnection.captureData = true;
      } else {
        localStorage.removeItem("fittingStartedSessionId");
        setRetryCount((count) => count + 1);
        setStartFittingError(true);
      }
    }
  };

  return (
    <Grid container>
      {startFittingError ? (
        <Grid item xs={12}>
          <Alert severity="error">
            <Typography>
              There was an issue with the server.
              {allowRetry
                ? " To retry, please click here"
                : " Feel free to proceed with the fitting, but please note this fitting session may not be logged correctly. Please notify your administrator."}
              <Button
                variant="contained"
                color={allowRetry ? "error" : "primary"}
                sx={{ marginLeft: 2 }}
                onClick={() => {
                  if (allowRetry) {
                    onRecordSwings();
                  } else {
                    increaseStep();
                    WebSocketConnection.captureData = true;
                  }
                }}
              >
                {allowRetry ? "Retry" : "Continue"}
              </Button>
            </Typography>
          </Alert>
        </Grid>
      ) : null}
      <Grid item xs={12}>
        <FittingInformation dataFilled={setFittingInfoFilled} />
      </Grid>
      <Grid item xs={12} sx={{ marginTop: 2 }} display="flex">
        <Typography variant="h4" sx={{ width: "70%" }}>
          Select the intial shaft and head
        </Typography>
        <Box display="flex" flexDirection="row-reverse" sx={{ width: "30%" }}>
          <Button
            variant="contained"
            onClick={onRecordSwings}
            disabled={
              clubState.selectedHead &&
              clubState.selectedShaft &&
              fittingInfoFilled
                ? false
                : true
            }
            sx={{ marginLeft: 2 }}
          >
            Record Swings
          </Button>
          <CopyButton
            copyElements={[clubState.selectedShaft, clubState.selectedHead]}
          />
        </Box>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <Selection
          headerText="Shaft Selection"
          currentSelection={
            clubState.selectedShaft ? clubState.selectedShaft : undefined
          }
          onSelection={(selection) => setSelectedShaft(selection)}
          tableRows={clubState.clubInfo.shafts.data}
          famFilterOpts={clubState.clubInfo.shafts.uniqueFamily}
          manFilterOpts={clubState.clubInfo.shafts.uniqueMan}
          dataType="shaft"
        />
      </Grid>
      <Grid item xs={12}>
        <Selection
          headerText="Head Selection"
          currentSelection={
            clubState.selectedHead ? clubState.selectedHead : undefined
          }
          onSelection={(selection) => setSelectedHead(selection)}
          tableRows={clubState.clubInfo.heads.data}
          famFilterOpts={clubState.clubInfo.heads.uniqueFamily}
          manFilterOpts={clubState.clubInfo.heads.uniqueMan}
          dataType="head"
        />
      </Grid>
    </Grid>
  );
};

export default InitialConfigs;
